module.exports = __webpack_public_path__ + "img/electrosun.96308430.jpg";